import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-sas-clinic-password-input',
  templateUrl: './sas-clinic-password-input.component.html',
  styleUrls: [
    './sas-clinic-password-input.component.css',
    '../style/global.css',
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => SasClinicPasswordInputComponent),
    },
  ],
})
export class SasClinicPasswordInputComponent implements ControlValueAccessor {
  @Input()
  placeholder = '';
  // @Input()
  // password = '';
  @Input()
  name = '';

  inputState = {
    isShow: false,
    isFocus: false,
  };

  private onTouchedCallback: () => void = () => {};
  private onChangeCallback: (_: any) => void = () => {};

  constructor() {}

  private _password = '';
  get password() {
    return this._password;
  }
  @Input()
  set password(val: string) {
    this._password = val;
    this.onChangeCallback(val);
  }

  writeValue(obj: any): void {
    this.password = obj;
  }
  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }
  setDisabledState?(isDisabled: boolean): void {}

  ngOnInit(): void {}

  get state() {
    if (this.password?.length || this.inputState?.isFocus)
      return 'v-label theme--light v-label--active primary--text';
    return 'v-label theme--light';
  }

  blur() {
    this.inputState.isFocus = false;
  }
  focus() {
    this.inputState.isFocus = true;
  }
}
